import { Pagination } from 'react-admin';

const DefaultPagination = props => <Pagination rowsPerPageOptions={[5, 10, 25, 50, 100]} {...props} />;

export { DefaultPagination }